import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch, watchEffect } from "@nuxtjs/composition-api";

import { useCartsDrawerEvents, useVuetify } from "@/composables";
import { useCartsStore, useCheckoutStore } from "@/store";


export default /*#__PURE__*/_defineComponent({
  __name: 'CartsDrawer',
  props: {
  value: {
    type: Boolean,
    default: false,
  },
},
  emits: ["input"],
  setup(__props, { emit }: { emit: ({
  (event: "input", value: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props;





const selectedCartId = ref<string | null>(null);
const showLoadingOverlay = ref(false);

const cartsStore = useCartsStore();
const checkoutStore = useCheckoutStore();
const vuetify = useVuetify();

const { sendCheckoutStartEvent, sendViewedMyCartsEvent, sendViewedSingleCartEvent } =
  useCartsDrawerEvents(selectedCartId);

watch([() => props.value, selectedCartId] as const, ([value, cartId]) => {
  if (!value) {
    return;
  }

  if (cartId) {
    sendViewedSingleCartEvent();
  } else {
    sendViewedMyCartsEvent();
  }
});

watchEffect(() => {
  if (selectedCartId.value && !cartsStore.carts[selectedCartId.value]) {
    selectedCartId.value = null;
    showLoadingOverlay.value = false;
  }
});

const drawerModel = computed({
  get() {
    return props.value;
  },
  set(newValue) {
    if (newValue === false) {
      selectedCartId.value = null;
    }
    emit("input", newValue);
  },
});

const drawerWidth = computed(() => {
  if (vuetify.breakpoint.xsOnly) {
    return "100%";
  }
  return "375";
});

const title = computed(() => {
  if (!selectedCartId.value) {
    return;
  }
  const retailerId = cartsStore.carts[selectedCartId.value]?.retailerId;
  return cartsStore.retailers[retailerId ?? ""]?.displayName;
});

const onCloseDrawer = () => {
  emit("input", false);
  selectedCartId.value = null;
};

const onViewCart = (cartId: string) => {
  emit("input", true);
  selectedCartId.value = cartId;
};

const onShowLoadingOverlay = (show: boolean) => {
  showLoadingOverlay.value = show;
};

const onCheckout = () => {
  sendCheckoutStartEvent();
  if (checkoutStore.checkout?.checkoutUrl) {
    window.location.assign(checkoutStore.checkout.checkoutUrl);
  }
};

return { __sfc: true,props, emit, selectedCartId, showLoadingOverlay, cartsStore, checkoutStore, vuetify, sendCheckoutStartEvent, sendViewedMyCartsEvent, sendViewedSingleCartEvent, drawerModel, drawerWidth, title, onCloseDrawer, onViewCart, onShowLoadingOverlay, onCheckout }
}

})